import { useMutation } from "@tanstack/react-query";
import {
  deleteAccountApi,
  logoutApi,
  memInfUpdateApi,
  memInfoApi,
} from "components/api/user";
import { useAuthContext } from "components/context/authContext";
import UserInf from "components/view/mypage/useInf";
import { IMemInf, memInfProps } from "interface/user";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { alertControl, successControl } from "util/commAction";

export default function UserInfPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isLogin } = useAuthContext();
  const { lodInf } = useAuthContext();

  const [userInf, setUserInf] = useState<IMemInf | null>(null);

  const formRef = useRef<HTMLFormElement>(null);

  //회원정보 조회
  const userInfMutation = useMutation({
    mutationFn: memInfoApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            setUserInf(res.data);
          },
        });
      }
    },
  });

  //회원정보 업데이트
  const infUpdateMutation = useMutation({
    mutationFn: memInfUpdateApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            alertControl({
              isOpen: true,
              inner: t("alr_mem_modify_info_cmpt"),
            });
          },
        });
      }
    },
  });
  const handleUpdateInf = () => {
    if (formRef.current) {
      const updateInfs = formRef.current.querySelectorAll(
        'input[data-type="U"]'
      ) as NodeListOf<HTMLInputElement>;

      let params = {} as memInfProps;
      updateInfs.forEach((input) => {
        const value = input.value;
        const name = input.name;

        if (input.type === "text") {
          input.role !== "select"
            ? (params = {
                ...params,
                [name]: value,
              })
            : (params = {
                ...params,
                [name]: input.dataset.code,
              });
        }

        if (input.type === "radio") {
          params = {
            ...params,
            [name]: input.id === "A" ? "" : input.id,
          };
        }
        if (input.type === "checkbox") {
          params = {
            ...params,
            [name]: input.checked ? "Y" : "N",
          };
        }
      });

      if (!Object.values(params).some((value) => !!value)) {
        return alertControl({
          isOpen: true,
          inner: t("alr_bk_update_prev"),
        });
      }

      alertControl({
        isOpen: true,
        inner: t("alr_mem_modify_info"),
        cncl_btn: true,
        click: () => {
          infUpdateMutation.mutate(params);
        },
      });
    }
  };

  //로그 아웃
  const logoutMutation = useMutation({
    mutationFn: logoutApi,
    onSuccess: (res) => {
      if (res) {
        const { status, data } = res;
        if (status.code === 0) {
          alertControl({
            isOpen: true,
            inner: "회원 탈퇴 하였습니다. / 홈페이지로 이동합니다.",
            click: () => {
              navigate("/" + (lodInf?.lodNo ?? ""));
              sessionStorage.removeItem("isLogin");
            },
          });
        }
      }
    },
  });

  //회원탈퇴
  const deleteAccoutMutation = useMutation({
    mutationFn: deleteAccountApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            // 회원 탈퇴 성공, 로그아웃 진행
            logoutMutation.mutate();
            // alertControl({
            //   isOpen: true,
            //   inner: t("alr_mdl_withdrawal_cmpt"),
            //   click: () => {
            //
            //     logoutMutation.mutate();
            //   },
            // });
          },
        });
      }
    },
  });

  const handleWithdrawal = () => {
    alertControl({
      isOpen: true,
      inner: t("alr_mdl_mem_withdrawal"),
      cncl_btn: true,
      click: () => {
        //회원탈퇴
        deleteAccoutMutation.mutate();
      },
    });
  };

  //초기 세팅
  useEffect(() => {
    const inputs = formRef.current?.querySelectorAll(
      "input"
    ) as NodeListOf<HTMLInputElement>;

    Array.from(inputs).forEach((input) => {
      input.setAttribute("data-type", "C");
    });
  }, []);

  useEffect(() => {
    if (isLogin) {
      userInfMutation.mutate();
    }
  }, []);

  return (
    <>
      <UserInf
        userInf={userInf}
        formRef={formRef}
        handleUpdateInf={handleUpdateInf}
        handleWithdrawal={handleWithdrawal}
      />
    </>
  );
}
